var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrianguleExclamation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 27,
    viewBox: "0 0 31 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.64359 25.5L15.5 1.5L29.3564 25.5H1.64359ZM15.7161 1.12565L15.7165 1.125L15.5 1L15.7165 1.125C15.7164 1.12521 15.7163 1.12543 15.7161 1.12565Z",
    fill: "white",
    stroke: "#FF2D52",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1422 14.5146H16.18V21.6655H15.1422V14.5146Z",
    fill: "#F44A5E",
    stroke: "#FF2D52"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1422 10.4395H16.18V11.4772H15.1422V10.4395Z",
    fill: "#F44A5E",
    stroke: "#FF2D52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrianguleExclamation);
export default __webpack_public_path__ + "static/media/triangule-exclamation.e5bc4a09cb6a87e040987d2d4a5cf051.svg";
export { ForwardRef as ReactComponent };